// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4820":"48bea4b736c427e1","5122":"9ea92664015bd46a","6512":"e9db4f52fa7942bf","7603":"61b5b0c9b07d0c9c","8926":"df514e2a9528603c"}[chunkId] + ".css";
};